import React from "react";
import "./PromoMarquee.css";

export default function PromoMarquee() {
  const message = "💥 GRAN DESCUENTO 3 x 2 en Poses de Personajes | 🔥 Aprovecha esta promoción 🔥|".toUpperCase();

  return (
    <div className="promo-marquee">
      <div className="promo-marquee__track">
        <div className="promo-marquee__group">
          <span>{message}</span>
          <span>{message}</span>
          <span>{message}</span>
        </div>

        <div className="promo-marquee__group" aria-hidden="true">
          <span>{message}</span>
          <span>{message}</span>
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
}